import type { MapClusterProps } from "./map-cluster.type";

import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useMemo } from "react";

import { MapClusterRenderer } from "../map-cluster-renderer";

export const useMapClusterHanlder = ({ advancedMarkers }: MapClusterProps) => {
  const map = useMap();

  const clusterer = useMemo(
    () =>
      map
        ? new MarkerClusterer({ map, renderer: new MapClusterRenderer() })
        : null,
    [map]
  );

  useEffect(() => {
    if (!clusterer || !advancedMarkers?.length) return;

    clusterer.clearMarkers();
    clusterer.addMarkers(advancedMarkers);
  }, [clusterer, advancedMarkers]);

  useEffect(() => {
    return () => {
      clusterer?.clearMarkers();
    };
  }, []);
};
